// Material
import { Stack, Typography } from "@mui/material";
// Images
import footerImg from "@/assets/images/widgets/Mail.svg";
import ReadAllImg from "@/assets/images/widgets/ReadAllNotifications.png";

interface INotificationListFooterProps {
	hasItems?: boolean;
}

export const NotificationListFooter = ({ hasItems }: Readonly<INotificationListFooterProps>) => {
	if (!hasItems) {
		return (
			<Stack direction="column" justifyItems="center" className="my-[15px]">
				<img src={ReadAllImg} style={{ margin: "auto" }} />
				<Typography className="text-center !font-sans !text-[14.5px]">
					You've <b>read</b> all your notifications <br /> from the last 30 days.
				</Typography>
			</Stack>
		);
	}

	return (
		<Stack direction="column" justifyItems="center" className="my-[15px]">
			<img src={footerImg} className="pb-2 h-16" alt="" />
			<Typography className="text-center !font-sans !text-[14.5px]">
				Showing notifications <br /> from last 30 days
			</Typography>
		</Stack>
	);
};
